import { CommonModule } from '@angular/common';
import { Component, EventEmitter, Input, Output } from '@angular/core';
import { BatchService } from '../Services/batch.service';
import { HttpClientModule } from '@angular/common/http';
import { NgxBarcode6Module } from 'ngx-barcode6';
import { ActivatedRoute, Router } from '@angular/router';
import Swal from 'sweetalert2';
import { FormsModule } from '@angular/forms';
import { PrinterpreferenceService } from '../Services/printerpreference.service';
import { environment } from './../../environments/environment';
//declare var qz: any;
@Component({
  selector: 'app-scanmedication',
  standalone: true,
  imports: [CommonModule, HttpClientModule, NgxBarcode6Module, FormsModule],
  templateUrl: './scanmedication.component.html',
  styleUrl: './scanmedication.component.css',
  providers: [BatchService, PrinterpreferenceService],
})
export class ScanmedicationComponent {
  printerSocket!: WebSocket;
  isNSTrayConnected: boolean = false;
  groupedMedications: any = {};
  batchData: any = {};
  prescriptionIds: string[] = [];
  scanStatuses: any = {};
  batchId: string = '';
  availablePrinters: string[] = [];
  expandedPrescriptionId: string | null = null;
  showPrinterSelectionModal: boolean = false;
  isScanComplete: boolean = false;
  selectedPrinter: string = '';
  instruction: string = '';
  dosage: string = '';
  medicineName: string = '';
  medicineId: string = '';
  currentPrescriptionIndex: number = 0;
  hasAlertedNSDisconnection: boolean = false;
  isComponentActive: boolean = true;
  viewOnly = false;
  showMedicationId = environment.showMedicationId;
  printMedication: {
    medicationName: string;
    medicineDosage: string;
    instruction: string;
    medicationId: string;
  } | null = null;
  printPackLabel: {
    prescriptionId: string;
    patientName: string;
    pharmacyId: string;
  } | null = null;
  @Output() isScanFinished = new EventEmitter<boolean>();
  @Input() isStartBtnClicked: boolean = false;
  @Output() printPackedList = new EventEmitter<void>();
  constructor(
    private _batchservice: BatchService,
    private activatedRoute: ActivatedRoute,
    private router: Router,
    private _printservice: PrinterpreferenceService,
  ) {}

  ngOnInit() {
    this.activatedRoute.paramMap.subscribe((params) => {
      this.batchId = params.get('batchId') || '';
    });

    this.activatedRoute.queryParamMap.subscribe((queryParams) => {
      const mode = queryParams.get('mode');
      this.viewOnly = mode === 'view';
    });

    this.loadBatchData();
    if (!this.viewOnly) {
      this.connectToNSTray();
    }
    // this.connectToNSTray();
  }
  ngOnDestroy() {
    // if (qz.websocket.isActive()) {
    //   qz.websocket.disconnect();
    // }
    this.isComponentActive = false;
    if (
      this.printerSocket &&
      this.printerSocket.readyState === WebSocket.OPEN
    ) {
      this.printerSocket.close();
    }
  }
  printPreference() {
    if (this.selectedPrinter) {
      this._printservice.setPrinterPreference(this.selectedPrinter);
      this.showPrinterSelectionModal = false;
    }
  }

  loadBatchData() {
    this.activatedRoute.paramMap.subscribe((params) => {
      this.batchId = params.get('batchId') || '';
      this._batchservice
        .getBatchById(this.batchId)
        .subscribe((response: any) => {
          this.batchData = response.result;
          // console.log(this.batchData);
          this.groupedMedications = {};
          this.scanStatuses = {};
          this.batchData.prescriptions.forEach((prescription: any) => {
            const key = prescription.rxId;
            this.groupedMedications[key] = {
              patientName: prescription.patientName,
              medicines: prescription.medications,
              pharmacyId: prescription.pharmacyId,
            };
            this.scanStatuses[key] = {};
            prescription.medications.forEach((medication: any) => {
              this.scanStatuses[key][medication.medicationId] =
                medication.isAvailable ? 'SCANNED' : 'PENDING';
            });
          });
          this.prescriptionIds = Object.keys(this.groupedMedications);
        });
    });
  }
  get currentPrescriptionId(): string {
    return this.prescriptionIds[this.currentPrescriptionIndex];
  }
  get currentPatientName(): string {
    return this.groupedMedications[this.currentPrescriptionId]?.patientName;
  }
  get currentMedicines(): any[] {
    return this.groupedMedications[this.currentPrescriptionId]?.medicines || [];
  }
  get isLastPrescription(): boolean {
    return this.currentPrescriptionIndex === this.prescriptionIds.length - 1;
  }
  get isFirstPrescription(): boolean {
    return this.currentPrescriptionIndex === 0;
  }
  jumpToPrescription(event: any) {
    const prescriptionId = event.target.value;
    const index = this.prescriptionIds.indexOf(prescriptionId);
    if (index !== -1) {
      this.currentPrescriptionIndex = index;
    }
  }
  nextPatient() {
    if (this.currentPrescriptionIndex < this.prescriptionIds.length - 1) {
      this.currentPrescriptionIndex++;
    }
  }
  previousPatient() {
    if (this.currentPrescriptionIndex > 0) {
      this.currentPrescriptionIndex--;
    }
  }
  finishScan() {
    Swal.fire({
      title: 'Please select',
      text: 'Finish scanning?',
      showCancelButton: true,
      confirmButtonColor: '#008000',
      cancelButtonColor: '#3085d6',
      cancelButtonText: 'Cancel',
      confirmButtonText: 'Finish',
      allowOutsideClick: false,
    }).then((result) => {
      if (result.isConfirmed) {
        const scanned = true;
        this.isScanComplete = scanned;
        this.isScanFinished.emit(scanned);
        this.printPackedList.emit();
        this.activatedRoute.paramMap.subscribe((params) => {
          this.batchId = params.get('batchId') || '';
          const status = 'Completed';
          this._batchservice
            .updateBatchStatus(this.batchId, status)
            .subscribe((response: any) => {
              // console.log(response);
            });
        });
      }
    });
  }
  listOfAvailability(medicationId: string) {
    if (!this.isNSTrayConnected) {
      Swal.fire({
        icon: 'warning',
        title: 'NS Tray Not Connected',
        text: 'Please start NS Tray before scanning.',
        timer: 2000,
        showConfirmButton: false,
      });
      return;
    }
    this.hasAlertedNSDisconnection = false;
    const prescriptionId = this.currentPrescriptionId;
    const currentGroup = this.groupedMedications[prescriptionId];
    const medication = currentGroup.medicines.find(
      (med: any) => med.medicationId === medicationId,
    );

    if (!medication) {
      Swal.fire({
        title: 'Warning!',
        text: `Wrong Medicine Scanned! ${medicationId}`,
        icon: 'error',
        timer: 2000,
        confirmButtonText: 'OK',
      });
      return;
    }

    const updatePayload = {
      batchId: this.batchId,
      prescriptions: [
        {
          rxId: prescriptionId,
          medications: [
            {
              medicationId: medication.medicationId,
              isAvailable: true,
            },
          ],
        },
      ],
    };

    this._batchservice.updateAvailability(updatePayload).subscribe({
      next: (res) => {
        medication.isAvailable = true;
        this.scanStatuses[prescriptionId][medication.medicationId] = 'SCANNED';
        this.medicineName = medication.medicationName;
        this.dosage = medication.dosage;
        this.instruction = medication.instruction;
        this.medicineId = medication.medicationId;
        // print section
        this.printMedication = {
          medicationName: this.medicineName,
          medicineDosage: this.dosage,
          instruction: this.instruction,
          medicationId: this.medicineId,
        };
        // setTimeout(() => {
        //   // this.printPdf('print-medicine');
        //   this.printSelectedPrinter('print-medicine');
        // }, 500);

        // if (this.isPrescriptionScanned(prescriptionId)) {
        //   this.printPackLabel = {
        //     prescriptionId: prescriptionId,
        //     patientName: this.groupedMedications[prescriptionId]?.patientName,
        //     pharmacyId: this.groupedMedications[prescriptionId]?.pharmacyId,
        //   };
        //   setTimeout(() => {
        //     // this.printPdf('print-pack-label');
        //     this.printSelectedPrinter('print-pack-label');
        //     // this.printPackLabel = null;
        //     if (
        //       this.currentPrescriptionIndex <
        //       this.prescriptionIds.length - 1
        //     ) {
        //       this.currentPrescriptionIndex++;
        //     }
        //   }, 1000);
        // }
        setTimeout(() => {
          this.printSelectedPrinter('print-medicine');
          if (this.isPrescriptionScanned(prescriptionId)) {
            this.printPackLabel = {
              prescriptionId: prescriptionId,
              patientName: this.groupedMedications[prescriptionId]?.patientName,
              pharmacyId: this.groupedMedications[prescriptionId]?.pharmacyId,
            };
            setTimeout(() => {
              this.printSelectedPrinter('print-pack-label');

              if (
                this.currentPrescriptionIndex <
                this.prescriptionIds.length - 1
              ) {
                this.currentPrescriptionIndex++;
              }
            }, 2000); // <-- your desired delay
          }
        }, 500);

        // Update batch status to PartialComplete
        const status = 'PartialComplete';
        this._batchservice.updateBatchStatus(this.batchId, status).subscribe();
        //reload batch
        this._batchservice
          .getBatchById(this.batchId)
          .subscribe((response: any) => {
            this.batchData = response.result;
          });
      },
      error: (err) => {
        Swal.fire({
          title: 'Error!',
          text: `Failed to update availability for ${medicationId}. Please scan again.`,
          icon: 'error',
          confirmButtonText: 'OK',
        });
      },
    });
  }
  isPrescriptionScanned(prescriptionId: string): boolean {
    const meds = this.groupedMedications[prescriptionId]?.medicines || [];
    return meds.every(
      (med: any) =>
        this.scanStatuses[prescriptionId]?.[med.medicationId] === 'SCANNED',
    );
  }
  getScannedCount(prescriptionId: string): number {
    return (
      this.groupedMedications[prescriptionId]?.medicines.filter(
        (med: any) =>
          this.scanStatuses[prescriptionId]?.[med.medicationId] === 'SCANNED',
      ).length || 0
    );
  }
  toggleCollapse(prescriptionId: string) {
    this.expandedPrescriptionId =
      this.expandedPrescriptionId === prescriptionId ? null : prescriptionId;
  }
  onCancel(medicine: any): void {
    const prescriptionId = this.currentPrescriptionId;
    const updatePayload = {
      batchId: this.batchId,
      prescriptions: [
        {
          rxId: prescriptionId,
          medications: [
            {
              medicationId: medicine.medicationId,
              isAvailable: false,
            },
          ],
        },
      ],
    };
    this._batchservice.updateAvailability(updatePayload).subscribe({
      next: (res) => {
        medicine.isAvailable = false;
        this.scanStatuses[prescriptionId][medicine.medicationId] = 'PENDING';
        this.scanStatuses[this.currentPrescriptionId][medicine.medicationId] =
          'PENDING';
      },
    });
  }
  connectToNSTray() {
    if (
      this.printerSocket &&
      this.printerSocket.readyState === WebSocket.OPEN
    ) {
      return;
    }
    const socket = new WebSocket('ws://localhost:8282');

    const showNSDisconnectedAlert = () => {
      if (!this.hasAlertedNSDisconnection) {
        this.hasAlertedNSDisconnection = true;

        Swal.fire({
          icon: 'warning',
          title: 'NS Tray Disconnected',
          text: 'Please check the connection.',
          timer: 2000,
          showConfirmButton: false,
        });
      }
    };

    socket.onopen = () => {
      this.isNSTrayConnected = true;
      this.hasAlertedNSDisconnection = false;
      console.log('Connected to NS Tray');
      const request = { type: 'get-printers' };
      socket.send(JSON.stringify(request));
    };

    socket.onmessage = (event) => {
      console.log('📨 Message from printer service:', event.data);
      try {
        const data = JSON.parse(event.data);

        if (data.type === 'printers' && Array.isArray(data.printers)) {
          this.availablePrinters = data.printers;

          const selectedPreference = this._printservice.getPrinterPreference();
          if (
            selectedPreference &&
            this.availablePrinters.includes(selectedPreference)
          ) {
            this.selectedPrinter = selectedPreference;
          } else {
            this.showPrinterSelectionModal = true;
            const interval = setInterval(() => {
              const pref = this._printservice.getPrinterPreference();
              if (pref) {
                this.selectedPrinter = pref;
                this.showPrinterSelectionModal = false;
                clearInterval(interval);
              }
            }, 300);
          }
        } else if (data.type === 'print-error') {
          console.error('❌ Print failed:', data.message);
          Swal.fire({
            icon: 'error',
            title: 'Print Failed',
            text: data.message,
            confirmButtonColor: '#d33',
          });
        } else if (data.type === 'print-success') {
          console.log('✅ Print success:', data.printer);
        }
      } catch (err) {
        console.error('⚠️ Failed to parse message from printer service:', err);
      }
    };

    socket.onerror = (error) => {
      if (this.isComponentActive) {
        this.isNSTrayConnected = false;
        showNSDisconnectedAlert();
      }
    };

    socket.onclose = () => {
      this.isNSTrayConnected = false;
      if (this.isComponentActive) {
        showNSDisconnectedAlert();
        console.log('NS Tray connection closed');
        setTimeout(() => {
          if (this.isComponentActive) {
            this.connectToNSTray();
          }
        }, 5000);
      }
    };
    this.printerSocket = socket;
  }
  // printSelectedPrinter(printId: string): void {
  //   const printer = this.selectedPrinter;
  //   const isPdf =
  //     printer.toLowerCase().includes('pdf') ||
  //     printer.toLowerCase().includes('canon');
  //   if (isPdf) {
  //     this.printPdfWithNSTray(printId, printer);
  //     return;
  //   }
  //   console.log('🔁 printSelectedPrinter called');
  //   console.log('Selected printer:', this.selectedPrinter);
  //   console.log(
  //     'Socket open?',
  //     this.printerSocket?.readyState === WebSocket.OPEN,
  //   );
  //   const isThermal = printer.toLowerCase().includes('fp-32l');
  //   if (
  //     isThermal &&
  //     this.printerSocket &&
  //     this.printerSocket.readyState === WebSocket.OPEN
  //   ) {
  //     const data = [
  //       '\x1B\x40',
  //       '\x1B\x61\x01',
  //       '\x1D\x21\x11',
  //       `${this.medicineName}\n`,
  //       '\x1D\x21\x00',
  //       `${this.dosage}\n`,
  //       `${this.instruction}\n`,
  //       '\n\n\n',
  //     ];
  //     const base64Raw = btoa(data.join(''));
  //     const payload = {
  //       type: 'print',
  //       contentType: 'raw',
  //       content: base64Raw,
  //       printer: this.selectedPrinter,
  //     };
  //     this.printerSocket.send(JSON.stringify(payload));
  //     console.log('Sent to WebSocket:', payload);
  //   } else {
  //     console.error('WebSocket not connected. Unable to print.');
  //   }
  // }
  printSelectedPrinter(printId: string): void {
    const printer = this.selectedPrinter;
    const printerLower = printer.toLowerCase();
    const isWindowsPrinter =
      printerLower.includes('pdf') ||
      printerLower.includes('canon') ||
      printerLower.includes('raster');

    if (isWindowsPrinter) {
      this.printPdfWithNSTray(printId, printer);
      return;
    }

    console.log('🔁 printSelectedPrinter called');
    console.log('Selected printer:', printer);
    console.log(
      'Socket open?',
      this.printerSocket?.readyState === WebSocket.OPEN,
    );
    const isPureThermal =
      printerLower.includes('fp-32l') && !printerLower.includes('raster');
    if (
      isPureThermal &&
      this.printerSocket &&
      this.printerSocket.readyState === WebSocket.OPEN
    ) {
      const data = [
        '\x1B\x40',
        '\x1B\x61\x01',
        '\x1D\x21\x11',
        `${this.medicineName}\r\n`,
        '\x1D\x21\x00',
        `${this.dosage}\r\n`,
        `${this.instruction}\r\n`,
        '\r\n\r\n',
      ];
      const base64Raw = btoa(data.join(''));
      const payload = {
        type: 'print',
        contentType: 'raw',
        content: base64Raw,
        printer: this.selectedPrinter,
      };
      this.printerSocket.send(JSON.stringify(payload));
      console.log('Sent to WebSocket:', payload);
    } else {
      console.error('WebSocket not connected or unsupported printer.');
    }
  }

  printPdfWithNSTray(printId: string, printer: string): void {
    setTimeout(() => {
      const printContents = document.getElementById(printId)?.innerHTML;
      if (!printContents) {
        console.error('❌ Print content not found');
        return;
      }

  //     const fullHtml = `
  //         <html>
  //           <head>
  //             <style>
  //               body {
  //                 font-family: Arial, sans-serif;
  //                 padding: 20px;
  //                 font-size: 14px;
  //               }
  //               h2 {
  //                 margin-top: 0;
  //                 font-size: 18px;
  //               }
  //               .medication-label {
  //                 border: 1px solid #000;
  //                 padding: 10px;
  //                 width: 350px;
  //               }
  //                 .medicine {
  //     min-height: 140px !important;
  //     display: flex;
  //     align-items: center;
  //     border: 1px solid #aaa;
  //     border-radius: 6px;
  //     padding: 12px;
  //     background-color: white !important;
  //     page-break-inside: avoid;
  //     min-height: 100px;
  //     position: relative;
  // }
  //     .text-section {
  //     flex: 1;
  //     padding-right: 20px;
  // }

  // .child-warning {
  //     color: #009e00;
  //     font-size: 13px;
  //     text-align: center;
  //     margin-bottom: 8px;
  // }

  // .med-name {
  //     text-align: center;
  //     font-size: 16px;
  //     font-weight: bold;
  //     text-transform: uppercase;
  //     margin: 5px 0;
  // }

  // .dose-instruction {
  //     text-align: center;
  //     font-size: 14px;
  //     font-weight: bold;
  //     margin: 5px 0 15px 0;
  // }

  // .barcode-section {
  //     position: absolute;
  //     right: -30px;
  //     top: 50%;
  //     transform: translateY(-50%) rotate(90deg);
  //     transform-origin: center;
  // }

  // .barcode svg {
  //     width: 100px;
  // }
  //             </style>
  //           </head>
  //           <body>
  //             <div class="medication-label">
  //               ${printContents}
  //             </div>
  //           </body>
  //         </html>
  //       `;

      const fullHtml = `
<html>
<head>
<style>

@page {
  size: 140mm 74mm;
  margin: 0;
}

html, body {
  width: 140mm;
  height: 74mm;
  margin: 0;
  padding: 0;
  overflow: hidden;
  font-family: Arial, sans-serif;
  font-size: 14px;
}

.medication-label {
  width: 140mm;
  height: 74mm;
  padding: 4mm;
  box-sizing: border-box;
}

.medicine {
  display: flex;
  align-items: center;
  position: relative;
  height: 100%;
}

.text-section {
  flex: 1;
  padding-right: 25mm;
}

.child-warning {
  color: #009e00;
  font-size: 16px;
  text-align: center;
  margin-bottom: 4px;
}

.med-name {
  text-align: center;
  font-size: 24px;
  font-weight: bold;
  text-transform: uppercase;
  margin: 4px 0;
}

.dose-instruction {
  text-align: center;
  font-size: 18px;
  font-weight: bold;
  margin: 4px 0;
}

.barcode-section {
  position: absolute;
  right: -10mm;
  top: 50%;
  transform: translateY(-50%) rotate(90deg);
  transform-origin: center;
}

.barcode svg {
  width: 90px;
  height: auto;
}

</style>
</head>

<body>

<div class="medication-label">

${printContents}

</div>

</body>

</html>
`;
      const base64Html = btoa(unescape(encodeURIComponent(fullHtml)));

      const payload = {
        type: 'print',
        contentType: 'html',
        content: base64Html,
        printer: printer,
      };

      // Send to WebSocket tray app
      if (
        this.printerSocket &&
        this.printerSocket.readyState === WebSocket.OPEN
      ) {
        this.printerSocket.send(JSON.stringify(payload));
        console.log('🟢 Sent HTML-to-PDF print job to custom tray app');
        console.log('📤 Payload:', payload);
      } else {
        console.error('🔴 WebSocket is not connected');
      }
    }, 500);
  }
}
